// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#556CAB","offColor":"#FFFFFF","secondaryColor":"#37415E","shadowColor":"#DBE0EC","secondaryOffColor":"#F5F8FF"};